const staticRoot = process.env.REACT_APP_STATIC_ASSETS;

export function StaticImage(props) {
  const { src, ...rest } = props;

  return <img {...rest} src={`${staticRoot}${src}`}></img>;
}
